import { useSelector } from 'react-redux';
import { RootState } from 'types/types';

export const useGetTileLayersUrls = (): {
  standard: string;
  humanitarian: string;
  bingGreyApiKey: string;
} => {
  const { applicationState } = useSelector((state: RootState) => state);

  const { applicationSettings } = applicationState;

  const BING_MAP_API_KEY = applicationSettings.BING_MAP_API_KEY;

  const TILE_LAYER_URLS = {
    standard: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    humanitarian: 'https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
    bingGreyApiKey: BING_MAP_API_KEY,
  };

  return TILE_LAYER_URLS;
};
